import { Gauge } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { EXAMS } from "../data/exams";
import { ExamBadge, useDocumentTitle } from "../components/ui";
import { buildDiagnostic, diagnosticQuestions, latestDiagnostic, PASS_PER_LEVEL, placementFromAttempt } from "../lib/diagnostic";
import { formatDateTime } from "../lib/dates";
import { sessionStore, useSession } from "../lib/session";
import { useProgress } from "../lib/store";
import { pick, useT } from "../i18n";

export function DiagnosticPage() {
  const t = useT();
  useDocumentTitle(t("Kiểm tra trình độ", "Placement test"));
  const p = useProgress();
  const active = useSession();
  const navigate = useNavigate();
  const n = diagnosticQuestions().length;
  const last = latestDiagnostic(p);
  const placement = last ? placementFromAttempt(last) : undefined;

  const start = () => {
    if (active && !window.confirm(t("Bạn đang làm dở một phiên khác. Bỏ phiên đó để bắt đầu kiểm tra?", "You have another session in progress. Discard it and start the placement test?"))) return;
    sessionStore.set(buildDiagnostic());
    navigate("/session");
  };

  return (
    <div style={{ maxWidth: 760, margin: "0 auto" }}>
      <h1><Gauge className="ico" size={28} aria-hidden="true" />{t("Kiểm tra trình độ", "Placement test")}</h1>
      <p className="muted">
        {t(
          `${n} câu tình huống, mỗi chứng chỉ ${n / EXAMS.length} câu theo độ khó tăng dần (~15 phút). Đúng từ ${PASS_PER_LEVEL} câu ở một cấp nghĩa là bạn đã vững cấp đó. Kết quả gợi ý chứng chỉ nên nhắm tới và bài học nên bắt đầu.`,
          `${n} scenario questions, ${n / EXAMS.length} per certification in rising difficulty (~15 minutes). Getting ${PASS_PER_LEVEL}+ right at a level means you're solid there. You'll get a recommended target certification and starting lesson.`,
        )}
      </p>
      <div className="card stack">
        <div className="row">
          {EXAMS.map((e) => <span key={e.id} className="row" style={{ gap: "0.35rem" }}><ExamBadge examId={e.id} size={24} /><span className="small">{e.code}</span></span>)}
        </div>
        <p className="small muted mb-0">{t("Đề bằng tiếng Anh như kỳ thi thật, không tính giờ.", "Questions are in English like the real exam; untimed.")}</p>
        <div className="row">
          <button type="button" className="btn primary lg" onClick={start}>{last ? t("Làm lại bài kiểm tra", "Retake the test") : t("Bắt đầu", "Start")}</button>
        </div>
      </div>

      {last && placement && (
        <div className="card mt">
          <h2>{t("Kết quả gần nhất", "Latest result")}</h2>
          <p className="small muted">{formatDateTime(last.finishedAt, p.lang)} · {last.correct}/{last.total}</p>
          <p><strong>{pick(placement.headline, p.lang)}</strong></p>
          <p className="small">{pick(placement.advice, p.lang)}</p>
          <div className="row">
            <Link className="btn primary" to={`/learn/${placement.firstLessonId}`}>{t("Bắt đầu bài học gợi ý", "Start the suggested lesson")}</Link>
            <Link className="btn" to={`/result/${last.id}`}>{t("Xem chi tiết", "View details")}</Link>
          </div>
        </div>
      )}
    </div>
  );
}
